/*
 * @Author: Hankill(hao.chen)
 * @Date: 2024-12-12 16:14:18
 * @LastEditors: Hankill(hao.chen)
 * @LastEditTime: 2024-12-13 10:38:32
 * @FilePath: /web_artemisads/src/utils/index.js
 * @Description: 工具函数
 */
import md5 from 'md5';
import axios from "axios";
import moment from 'moment';
import { message } from "ant-design-vue";

/**
 * @description: 复制到粘贴板
 * @param {*} text
 * @return {*} viod
 */
export function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          message.success('Copied Successfully');
        })
        .catch((err) => {
          console.error('复制失败:', err);
        });
    } else {
      console.warn('Clipboard API 不支持，使用 fallback 方法');
      fallbackCopyToClipboard(text);
    }
  }
  
  // Fallback 方法（使用 execCommand）
  function fallbackCopyToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      message.success('Copied Successfully');
    } catch (err) {
      console.error('复制失败:', err);
    }
    document.body.removeChild(textarea);
  }

/**
 * @description: 格式化传入文本为富文本样式
 * @param {*} body
 * @return {*} 富文本
 */
export function formattedText (body) {
    // 将换行符转换为 <br>，链接转换为超链接
    const open = '<p style="font-family: Sora; font-weight: 400; font-size: 14px; color: rgba(15, 6, 41, .9); letter-spacing: 0.4px; margin-top: 8px; line-height: 22px; min-height: 22px;">';
    const close = '</p>';
    return open
    + body.trim().replace(/(https?\:\/\/[^\s\r\n\b]+)/g, '<a href="$1" target="_blank">$1</a>').replace(/\r\n/g, '\n').replace(/\n+/g, close + '\n' + open)
    + close
}

/**
 * @file: blob文件
 * @url
 * @return res
 */

const imageRequest = axios.create({
  baseURL: 'api/',
  timeout: 20000,
  headers: {
    'Content-Type': 'image/jpeg',
    // 'Authorization': store.state.token
  }
});

async function hashSHA256(message) {
  // 将字符串转换为 Uint8Array
  const encoder = new TextEncoder();
  const data = encoder.encode(message);

  // 调用 SubtleCrypto 的 digest 方法生成 SHA-256 哈希
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  // 将 ArrayBuffer 转换为十六进制字符串
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
  return hashHex;
}
export const uploadFile = async ({ file, url }) =>  {
  const ts = moment().format('x')
  const accessToken = '7uddl5'
  const  biz = 'artemisads'
  const secret = await hashSHA256('madash' + ts);
  let res = {};
  console.log(file, url, 'file, url')
  if (file) {
    http://dev-cn.your-api-server.com/api/artemisads/v1/common/upload

    res = await imageRequest.post(`http://118.31.23.117:8077/api/artemisads/v1/common/upload?biz=${biz}&accessToken=${accessToken}&secret=${secret}&ts=${ts}`, file);
  } else {
    res = await imageRequest.post(`http://118.31.23.117:8077/api/artemisads/v1/common/upload/${url}?biz=${biz}&accessToken=${accessToken}&secret=${secret}&ts=${ts}`);
  }
  if (res.data?.success) {
    // let protocal = 'https://', cacheServer = `imgcache.dealmoon.com`;
    // let imageUrl = res.data.data.url;
    // imageUrl = imageUrl.replace(protocal, '');
    // imageUrl = `${imageUrl}_0_0_1`;
    // // keep secret!
    // let key = md5(`&6#dealmoon.magic.GG${imageUrl}`).substr(0, 4);
    // imageUrl = `${protocal}${cacheServer}/${imageUrl}_${key}.jpg`;
    // res.data.data.url = imageUrl;
    return res.data;
  }
  return res;
}
export const uploadImg = async ({ file, url }) => {
  const ts = moment().format('x'), accessToken = '7uddl5',  biz = 'artemisads';
  const secret = await hashSHA256('madash' + ts);
  let res = {};
  if (file) {
    res = await imageRequest.put(`https://thumbimg.artemisads.com/api/storage/v2/file/a.jpg?biz=${biz}&accessToken=${accessToken}&secret=${secret}&ts=${ts}`, file);
  } else {
    res = await imageRequest.put(`https://thumbimg.artemisads.com/api/storage/v2/file/${url}?biz=${biz}&accessToken=${accessToken}&secret=${secret}&ts=${ts}`);
  }
  if (res.data?.success) {
    // let protocal = 'https://', cacheServer = `imgcache.dealmoon.com`;
    // let imageUrl = res.data.data.url;
    // imageUrl = imageUrl.replace(protocal, '');
    // imageUrl = `${imageUrl}_0_0_1`;
    // // keep secret!
    // let key = md5(`&6#dealmoon.magic.GG${imageUrl}`).substr(0, 4);
    // imageUrl = `${protocal}${cacheServer}/${imageUrl}_${key}.jpg`;
    // res.data.data.url = imageUrl;
    return res.data;
  }
  return res;
}

export const imgCache = (url = '', size = '0_0', type = '1') => {
  if (!url) return '';
  let protocal = 'https:';
  let orginUrl = '';
  // 如果图片是//开头，加上protocal，防止生成连接后出错
  if (/^\/\//.test(url)) {
    url = `${protocal}//${url}`;
  }
  // 如果判断图片已经做了转换，提取出原图再转换
  let regexp = /^((https?\:)\/\/\w+cache\.dealmoon.com\/)(.+)(_\d+_\d+_\d+_[0-9a-z]{4}\.[\w]{2,4})$/;
  let matches = url.match(regexp);
  if (matches === null) {
    orginUrl = url.replace(/^https?:\/\//, '');
  } else {
    [, , protocal, orginUrl] = matches;
  }
  let commboUrl = `${orginUrl}_${size}_${type}`;
  // keep secret!
  let key = md5(`&6#dealmoon.magic.GG${commboUrl}`).substr(0, 4);
  let suffix = url.split('.').pop();
  // 获取图片服务器
  let cacheServer = `imgcache.dealmoon.com`;
  return `${protocal}//${cacheServer}/${commboUrl}_${key}.${suffix || 'jpg'}`;
};

export function getTimeZoneStr(countryCode = 'US', isShort = true) {
  if (countryCode == 'US' || countryCode == 'CA') {
    return isShort ? 'PT' : 'Paciﬁc Time Zone (PT)'
  } else if (countryCode == 'FR' || countryCode == 'DE') {
    return isShort ? 'CET' : 'Central European Time Zone (CET)'
  } else if (countryCode == 'UK') {
    return isShort ? 'GMT' : 'Greenwich Mean Time Zone (GMT)'
  }
}

export function buildQuery(data) {
  return Object.keys(data).map(key => {
    return `${key}=${data[key]}`
  }).join('&')
}

export function getQuery(name, u = location.href) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
    r = u.substr(u.indexOf("?") + 1).match(reg)

  return r != null ? r[2] : "";
}

/**
 * 首字母大写
 * @param {*} str 
 * @returns 
 * @since 2025/05/26 15:52:25
 */
export function capitalize(str) {
  console.log(str,'str')
  if (!str) return '';
  if(typeof str !== 'string') return str
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * 格式化时间显示
 * @param {string|array} time - 时间字符串或数组
 * @returns {string} 格式化后的时间字符串
 * @since 2025/05/26 16:00:00
 */
export function setTime(time,isFormat = true) {
  if(!time) return '--'
  if (Array.isArray(time)) {
    return `${time[0]}.${time[1]}.${time[2]}`
  } else {
    if(!isFormat) return time
    return time.replaceAll('-','.')
  }
}

/**
 * @description: 统计数组中品牌名称的出现次数
 * @param {Array} data - 包含品牌数据的数组
 * @param {string} brandNamePath - 品牌名称在对象中的路径，默认为 'brandVO.amazonBrandName'
 * @return {Object} 返回品牌名称及其出现次数的映射对象
 */
export function countBrandNames(data, brandNamePath = 'brand.amazonBrandName') {
  return data.reduce((acc, item) => {
    // 支持嵌套路径访问，如 'brandVO.amazonBrandName'
    const brandName = brandNamePath.split('.').reduce((obj, key) => obj?.[key], item);
    
    if (brandName) {
      acc[brandName] = (acc[brandName] || 0) + 1;
    }
    return acc;
  }, {});
}

/**
 * @description: 数字千位分隔符格式化
 * @param {number|string} num - 需要格式化的数字
 * @param {string} separator - 分隔符，默认为逗号
 * @return {string} 格式化后的字符串
 */
export function formatNumber(num, separator = ',') {
  if (num === null || num === undefined || num === '') {
    return '--';
  }
  
  // 转换为字符串
  const numStr = String(num);
  
  // 处理小数
  const parts = numStr.split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];
  
  // 添加千位分隔符
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  
  // 如果有小数部分，拼接回去
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;

}
/**
 * @description: 获取数字的绝对值
 * @param {number|string} record - 需要获取绝对值的数字或数字字符串
 * @return {number|string} 数字的绝对值，非数字返回'--'
 */
export const setUnit = (record) => {
  if(record||record==0){
    if (record > 0) {
    return '+'
  }
  else if(record == 0){
    return ''
  }
  else {
    return '-'
  }
  }
  else{
    return ''
  }
}
/**
 * @description: 获取数字的绝对值
 * @param {number|string} record - 需要获取绝对值的数字或数字字符串
 * @return {number|string} 数字的绝对值，非数字返回'--'
 */
export const setAmount = (record) => {
  if(record||record==0){
  return Math.abs(record)
  }
  else{
    return '--'
  }
}

/** 账单待支付金额（含 adjustment 等负数的符号处理） */
export const getBillPaymentAmount = (item) => {
  const amount = Number(item?.amount ?? 0)
  const paidAmount = Number(item?.paidAmount ?? 0)
  const pendingRaw = item?.paymentPendingAmount

  let pending
  if (pendingRaw !== undefined && pendingRaw !== null && pendingRaw !== '') {
    pending = Number(pendingRaw)
  } else {
    pending = amount - paidAmount
  }

  if (Number.isNaN(pending)) {
    return amount - paidAmount
  }

  const billingType = String(item?.billingType || '').toUpperCase()
  if (billingType !== 'MONTHLY' && amount < 0 && pending > 0) {
    return -pending
  }

  return pending
}

/**
 * @description: 首字母转小写
 * @param {string} str - 需要转换的字符串
 * @return {string} 首字母小写的字符串
 */
export function lowercaseFirst(str) {
  if (!str) return '';
  return str.charAt(0).toLowerCase() + str.slice(1);
}
/**
 * @description: 大写转小写
 * @param {string} str - 需要转换的字符串
 * @return {string} 大写转小写
 */
export function convertToLowercase(str) {
  return str.toUpperCase().toLowerCase();
}